import { Box, Flex, Image, Link, Heading, For} from "@chakra-ui/react";
import Container from '@/components/partials/Container';
import { socialList } from '@/helpers/constants';
import LogoSvg from '@/lib/logo';
import { AddressInfo, LuIcon } from "@/components/partials/Helpers";
import revalidate from '@/lib/revalidate';

export default async function Footer({ menu }) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/footer`, {
    next: revalidate('REVALIDATE_FOOTER')
  });

  const result = await res.json();
  const { data: categories } = result;

  const catListA = categories.slice(0, 8);
  const catListB = categories.slice(8, 16);

  const socials = socialList();

  return (
    <>
      <Box w="100%" bgColor="gray.500" color="white" py="12" borderTopWidth="2px" borderColor="blue.500">
        <Container>
          <Flex
            flexDirection={{ base: 'column', lg: 'row' }}
            justifyContent={{ base: 'center', lg: 'space-between' }}
            alignItems={{ base: 'center', lg: 'start' }}
            textAlign={{ base: 'center', lg: 'left' }}
            >
            <Box mb={{ base: '8', lg: '0' }} w="100%" maxW={{ base: '320px', lg: '280px' }}>
              <Box w="100%">
                <LogoSvg
                color1="#FFFFFF"
                color2="#00BDFF"
                hasBottom={true}
                />
              </Box>

              <Box whiteSpace="pre-line" fontSize="1em" mt="4">
                <AddressInfo joinType={`\n`} />
              </Box>
            </Box>

            <Box mb={{ base: '8', lg: '0' }}>
              <Heading as="h1" fontFamily="inherit" mb="2">Institucional</Heading>

              <Flex>
                <Flex as="ul" flexDirection="column" listStylePosition="inside">
                  <For each={menu}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={ item.href } title={item.label} color="inherit" _hover={{ color: 'blue.500'}}>
                        { item.label }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>
              </Flex>
            </Box>

            <Box mb={{ base: '8', lg: '0' }}>
              <Heading as="h1" fontFamily="inherit" mb="2">Categorias</Heading>

              <Flex>
                <Flex as="ul" flexDirection="column" listStylePosition="inside">
                  <For each={catListA}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={`/categoria/${item.taxSlug}`} title={item.taxName} color="inherit" _hover={{ color: 'blue.500'}} >
                          { item.taxName }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>

                <Flex ml="14" as="ul" flexDirection="column" listStylePosition="inside">
                  <For each={catListB}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={`/categoria/${item.taxSlug}`} title={item.taxName} color="inherit" _hover={{ color: 'blue.500'}} >
                          { item.taxName }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>
              </Flex>
            </Box>

            <Box>
              <Box>
                <Heading as="h1" fontFamily="inherit" mb="2">Redes Sociais</Heading>

                <Flex>
                  <For each={socials}>
                    {(item, key) => (
                      <Box as={Link} key={key} mr="2" color="white" _hover={{ color: 'blue.500'}}>
                        <LuIcon icon={item.icon} size="30px" />
                      </Box>
                    )}
                  </For>
                </Flex>
              </Box>

              <Box mt="6">
                <Link target="_blank" href="https://cloudflash.com.br">
                  <Image
                    src="https://r2.flize.cloud/cloudflash/stamp_white.png"
                    alt="Hospedado por CloudFlash"
                  />
                </Link>
              </Box>
            </Box>
          </Flex>


        </Container>
      </Box>

      <Box
        position="fixed"
        right="30px"
        bottom="30px"
        zIndex="99999"
        w="60px"
        h="60px"
        bgColor="#25d366"
        fontSize="30px"
        color="white"
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="100%"
        boxShadow="0 0 8px 0 rgba(0,0,0,0.44)"
        animationName="shakeX"
        animationDuration="1s"
        animationTimingFunction="ease-in-out"
        animationIterationCount="infinite"
      >
        <Link color="white" href="https://chat.whatsapp.com/B7cOj8oeNhj6GxATZcRSQM" target="_blank">
          <svg width="36px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#fff" d="M476.9 161.1C435 119.1 379.2 96 319.9 96C197.5 96 97.9 195.6 97.9 318C97.9 357.1 108.1 395.3 127.5 429L96 544L213.7 513.1C246.1 530.8 282.6 540.1 319.8 540.1L319.9 540.1C442.2 540.1 544 440.5 544 318.1C544 258.8 518.8 203.1 476.9 161.1zM319.9 502.7C286.7 502.7 254.2 493.8 225.9 477L219.2 473L149.4 491.3L168 423.2L163.6 416.2C145.1 386.8 135.4 352.9 135.4 318C135.4 216.3 218.2 133.5 320 133.5C369.3 133.5 415.6 152.7 450.4 187.6C485.2 222.5 506.6 268.8 506.5 318.1C506.5 419.9 421.6 502.7 319.9 502.7zM421.1 364.5C415.6 361.7 388.3 348.3 383.2 346.5C378.1 344.6 374.4 343.7 370.7 349.3C367 354.9 356.4 367.3 353.1 371.1C349.9 374.8 346.6 375.3 341.1 372.5C308.5 356.2 287.1 343.4 265.6 306.5C259.9 296.7 271.3 297.4 281.9 276.2C283.7 272.5 282.8 269.3 281.4 266.5C280 263.7 268.9 236.4 264.3 225.3C259.8 214.5 255.2 216 251.8 215.8C248.6 215.6 244.9 215.6 241.2 215.6C237.5 215.6 231.5 217 226.4 222.5C221.3 228.1 207 241.5 207 268.8C207 296.1 226.9 322.5 229.6 326.2C232.4 329.9 268.7 385.9 324.4 410C359.6 425.2 373.4 426.5 391 423.9C401.7 422.3 423.8 410.5 428.4 397.5C433 384.5 433 373.4 431.6 371.1C430.3 368.6 426.6 367.2 421.1 364.5z"/></svg>
        </Link>
      </Box>

      <Box w="100%" textAlign="center" fontSize="xs" borderTopWidth="1px" borderColor="blue.500" bgColor="gray.500" color="white" p="4">
        Desenvolvido por <Link target="_blank" href="https://flize.com.br" color="inherit">Flize Tecnologia</Link>
      </Box>
    </>
  )
}
